var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry, actionExecutionLocations) {
  pluginRegistry.registerDeploymentAction("Octopus.TomcatState", function(busy, octopusRepository) {
      return {
          executionLocation: actionExecutionLocations.alwaysOnTarget,
          canChooseRoles: true,
          canHaveChildren: function() { return true; },
          canBeChild: true,
          hasPackages: function(action) { return false; },
          summaryTemplateUrl: "areas/projects/actions/tomcat/Octopus.TomcatState_summary.html",
          editTemplateUrl: "areas/projects/actions/tomcat/Octopus.TomcatState_edit.html",
          features: {
              permanent: ["Octopus.Features.TomcatStateManager"],
              optional: [],
              initial: []
          },
          summaryLink: function ($scope, element) {

          }
      };
    });
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/tomcat/Octopus.TomcatState.js
// module id = 6582157088755196
// module chunks = 1